<template>
  <Loader v-if="isLoading" />

  <div class="b-pop-up__content">
    <div
      class="b-pop-up__alert-success__icon b-pop-up__alert-success__icon--warning"></div>
    <div class="b-pop-up__alert-success__title">
      {{ dictionary.voucherWarningTitle }}
    </div>
    <div class="b-pop-up__alert-success__text">
      {{ dictionary.voucherWarningDescription }}
    </div>
    <button
      class="p-booking__modal__confirm__cta btn-primary-orange"
      type="button"
      @click="onClickConfirm">
      <span>{{ dictionary.addVoucherCta }}</span>
    </button>
    <button
      type="button"
      class="p-booking__modal__confirm__cta btn-secondary"
      @click="() => emit('back-to-add-vouchers')">
      <span>{{ dictionary.cancelVoucher }}</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Loader from './../../../components/Shared/Loader.vue'

const emit = defineEmits(['back-to-add-vouchers', 'confirm-vouchers'])
const isLoading = ref(false)

const onClickConfirm = () => {
  isLoading.value = true
  emit('confirm-vouchers')
}
</script>
